import { GlobalConstants } from './global-constants';
import { Mail } from './mail';

export const interfaces: any[] = [
    GlobalConstants,
    Mail
];

export * from './global-constants';
export * from './mail';